import React from "react";
import { connect } from 'react-redux';
import SupportedClientTypeForm from "./SupportedClientTypeForm";
import * as Yup from "yup";
import * as actions from './store/supportedClientTypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";

const SupportedClientTypeCreate = props => {
    const { activeCustomerID, translations, createSupportedClientType, permissions } = props;

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['CustomerID'] = activeCustomerID;
        let result = await createSupportedClientType({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Key: '',
        Name: '',
        MajorVersion: 0,
        MinorVersion: 0,
        BuildNumber: 0
    };

    let formSettings = {
        Validation: {
            Key: Yup.string().required("Key"),
            Name: Yup.string().required("Required"),
            MajorVersion: Yup.number().min(0).required('Required'),
            MinorVersion: Yup.number().min(0).required('Required'),
            BuildNumber: Yup.number().min(0).required('Required')
        },
        FormTitle: translations["create_supported_client_type"] || "Create supported client type",
        ButtonSubmit: hasPermission(permissions, 'supported_client_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return <SupportedClientTypeForm
        formSettings={formSettings}
        initialValues={initialValues}
        handleSubmit={handleSubmit}
        translations={translations}
    />
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createSupportedClientType: data => dispatch(actions.createSupportedClientType(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SupportedClientTypeCreate);
